import { useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Text, Container, useResizeObserver, Image } from '@weareconceptstudio/core';

//* Styles
import ContentAboutStyle from './style';

//* Component
import { withUIContext } from '@/context';

const ContentAbout = ({ image, vision, mission, winWidth }) => {
	//! Ref
	const wrapperRef = useRef();
	const scrollTriggerRef = useRef();

	//! Resize
	const resize = useResizeObserver(typeof document !== 'undefined' ? document.querySelector('body') : null);

	useEffect(() => {
		scrollTriggerRef.current = ScrollTrigger.create({
			start: '20% 90%',
			end: '20% 90%',
			// markers: true,
			trigger: wrapperRef.current,

			onEnter: () => {
				gsap.to('.image-0', { x: 0, y: 0, duration: 0.8, ease: 'power2.out' });
				gsap.to('.image-1', { x: 0, y: 0, duration: 0.7, ease: 'power2.out' });
				gsap.to('.image-2', { x: 0, y: 0, duration: 0.7, ease: 'power2.out' });
				gsap.to('.mission', { x: 0, y: 0, duration: 0.8, ease: 'power2.out' });
				gsap.to('.image-3', { x: 0, y: 0, duration: 0.6, ease: 'power2.out' });
				gsap.to('.image-4', { x: 0, y: 0, duration: 0.7, ease: 'power2.out' });
				gsap.to('.image-5', { x: 0, y: 0, duration: 0.8, ease: 'power2.out' });
				gsap.to('.vision', { x: 0, y: 0, duration: 0.6, ease: 'power2.out' });
				gsap.to('.image-6', { x: 0, y: 0, duration: 0.7, ease: 'power2.out' });
			},
		});

		return () => {
			if (scrollTriggerRef.current) scrollTriggerRef.current.kill();
		};
	}, [resize]);

	return (
		<ContentAboutStyle>
			<div
				ref={wrapperRef}
				className='wrapper-content'>
				<Container
					isSection
					row>
					<div className='left-block grid-container col-8 col-m-12'>
						<div className='stroke-1'>
							<div className='empty' />
							<div className='image-0 wrapper-image'>
								<Image src={image[0]?.src} />
							</div>
							<div className='image-1 wrapper-image middle'>
								<Image src={image[1]?.src} />
							</div>
						</div>
						<div className='stroke-2'>
							<div className='mission-vision mission'>
								<Text className={'uppercase h4 title'}>{mission.title}</Text>
								<Text className={'p2 description'}>{mission.description}</Text>
							</div>
							<div className='wrapper-inner-stroke-2'>
								<div className='image-2 wrapper-image'>
									<Image src={image[2]?.src} />
								</div>
								{winWidth < 768 ? (
									<div className='image-6 wrapper-image middle'>
										<Image src={image[6]?.src} />
									</div>
								) : null}
							</div>
						</div>
						{winWidth < 768 ? (
							<div className='mission-vision vision'>
								<Text className={'uppercase h4 title'}>{vision.title}</Text>
								<Text className={'p2 description'}>{vision.description}</Text>
							</div>
						) : null}
						<div className='stroke-3'>
							<div className='image-3 wrapper-image'>
								<Image src={image[3]?.src} />
							</div>

							<div className='image-4 wrapper-image middle-bottom'>
								<Image
									src={image[4]?.src}
									className={'image-bottom-addHeight'}
								/>
							</div>

							<div className='image-5 wrapper-image'>
								<Image src={image[5]?.src} />
							</div>
						</div>
					</div>
					{winWidth < 768 ? null : (
						<div className='right-block flex-container col-4 col-m-12'>
							<div className='wrapper-right-image'>
								<div className='image-6 wrapper-image'>
									<Image src={image[6]?.src} />
								</div>
								<div className='empty' />
							</div>
							<div className='mission-vision vision'>
								<Text className={'uppercase h4 title'}>{vision.title}</Text>
								<Text className={'p2 description'}>{vision.description}</Text>
							</div>
						</div>
					)}
				</Container>
			</div>
		</ContentAboutStyle>
	);
};

export default withUIContext(ContentAbout, ['winWidth']);
